// extracted by mini-css-extract-plugin
export default {"container":"ClickableArea_container__L-D4k","disabled":"ClickableArea_disabled__cgzW4"};